﻿import { RadioGroup } from "@headlessui/react";
import { ReactNode } from "react";

import { RateCard } from "@/components/Layout/Rates/RateCard/RateCard";
import {
  getDiscountedValue,
  stripCurrencyPrefix,
  TransformedProduct,
} from "@/utils/tariffUtils";

interface RateCardGridProps {
  /** Names the radio group, e.g. the visible tab label. */
  ariaLabel: string;
  value: string | undefined;
  products: TransformedProduct[];
  hint?: ReactNode;
  disabledProductIds?: number[];
  tribeDiscount?: number;
  /** When set, the matching product card shows a chip with this label. */
  currentProductId?: number;
  currentLabel?: string;
  onChange: (value: string) => void;
}

export const RateCardGrid = ({
  ariaLabel,
  value,
  products,
  hint,
  disabledProductIds,
  tribeDiscount,
  currentProductId,
  currentLabel,
  onChange,
}: RateCardGridProps) => (
  <div className="flex w-full flex-col gap-6">
    {hint}
    <RadioGroup aria-label={ariaLabel} value={value ?? ""} onChange={onChange}>
      <div className="grid gap-6 tablet:grid-cols-2 desktop:grid-cols-3">
        {products.map((product) => {
          const discountedPrice =
            tribeDiscount && tribeDiscount > 0
              ? getDiscountedValue({
                  value: product.chargeFlat,
                  discountPercent: tribeDiscount,
                })
              : undefined;

          return (
            <RateCard
              key={product.id}
              product={
                discountedPrice
                  ? { ...product, chargeFlat: discountedPrice }
                  : product
              }
              originalPrice={
                discountedPrice
                  ? stripCurrencyPrefix(product.chargeFlat)
                  : undefined
              }
              disabled={
                !!product.id && !!disabledProductIds?.includes(product.id)
              }
              currentLabel={
                currentProductId !== undefined &&
                product.id === currentProductId
                  ? currentLabel
                  : undefined
              }
            />
          );
        })}
      </div>
    </RadioGroup>
  </div>
);
